import { Gender } from "@/api";

export default function getGender(gender: Gender) {
  switch (gender) {
    case Gender.Female:
      return "Vrouw";
    case Gender.Male:
      return "Man";
    case Gender.X:
      return "X";
    case Gender.Unknown:
      return "Zeg ik liever niet";
    default:
      return "Onbekend";
  }
}
